import BaseStore from './base';
import api, { Command } from '../api';
export class PersonsStore extends BaseStore {
    constructor() {
        super({
            loading: false,
            total: -1,
            persons: []
        });
    }
    async init() {
        const { total, loading } = this.get();
        if (total === -1 && !loading) {
            this.loadAll();
        }
    }
    async updatePerson(data) {
        if (data.id) {
            try {
                const resp = await this.load(data.id, () => api.put(Command.Person, data));
                this.storePerson(resp.lecturer);
                return resp.lecturer;
            }
            catch (err) {
                console.error(err);
            }
        }
    }
    async createPerson(data) {
        try {
            const resp = await api.post(Command.Person, data);
            this.storePerson(resp.lecturer);
            return resp.lecturer;
        }
        catch (err) {
            console.error(err);
        }
    }
    loadAll() {
        this.update({ loading: true });
        const next = () => {
            const { persons, total } = this.get();
            if (total === -1 || persons.length < total) {
                this.loadBatch().then(next);
            }
        };
        next();
    }
    async loadBatch() {
        let { persons } = this.get();
        const l = 30;
        const p = Math.floor(persons.length / l);
        console.log('load persons', { p, l });
        const resp = await api.get(Command.PersonList, { p, l });
        const lookup = new Map(persons.map((p, i) => [p.id, i]));
        persons = [...persons];
        resp.lecturers.forEach(p => {
            if (lookup.has(p.id)) {
                const ix = lookup.get(p.id);
                persons[ix] = p;
            }
            else {
                persons.push(p);
            }
        });
        this.update({
            persons,
            total: resp.paging.countAll
        });
    }
    /**
     * Обёртка для загрузки данных с индикацией загрузки в модели
     */
    load(id, cb) {
        try {
            this.update({ loading: id });
            return cb();
        }
        finally {
            const { loading } = this.get();
            if (loading === id) {
                this.update({ loading: false });
            }
        }
    }
    storePerson(data) {
        let { persons } = this.get();
        const ix = persons.findIndex(p => p.id === data.id);
        persons = [...persons];
        if (ix !== -1) {
            persons[ix] = data;
        }
        else {
            persons.push(data);
        }
        this.update({ persons });
    }
}
const persons = new PersonsStore();
export default persons;
